import { render, staticRenderFns } from "./NexelTroubleTickets.vue?vue&type=template&id=4bdb747a&v-if=apiResponse"
import script from "./NexelTroubleTickets.vue?vue&type=script&lang=js"
export * from "./NexelTroubleTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports